module.exports = __webpack_public_path__ + "static/media/undraw_cloud_files_wmo8.ad0df4f6.svg";